// src/store/subscriptionPurchaseModalManagment/reducer.ts

import {
  SubscriptionPurchaseModalState,
  initialState,
  SubscriptionPurchaseModalActionTypes,
  OPEN_SUBSCRIPTION_PURCHASE_MODAL,
  CLOSE_SUBSCRIPTION_PURCHASE_MODAL,
} from './types';

const subscriptionPurchaseModalReducer = (
  state: SubscriptionPurchaseModalState = initialState,
  action: SubscriptionPurchaseModalActionTypes
): SubscriptionPurchaseModalState => {
  switch (action.type) {
    case OPEN_SUBSCRIPTION_PURCHASE_MODAL:
      return { open: true, ...action.payload };

    case CLOSE_SUBSCRIPTION_PURCHASE_MODAL:
      return initialState;

    default:
      return state;
  }
};

export default subscriptionPurchaseModalReducer;
